import ArticleCard from '@/components/feature/ArticleCard';
import type { ArticleItem } from '@/mocks/gossip';

interface RelatedArticlesProps {
  items: ArticleItem[];
}

export default function RelatedArticles({ items }: RelatedArticlesProps) {
  if (items.length === 0) return null;

  return (
    <section className="border-t border-background-200 bg-background-100 py-14">
      <div className="mx-auto max-w-[1240px] px-4 md:px-8">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary-600">
              <span className="h-3 w-1 rounded-full bg-primary-500" aria-hidden="true" />
              相关推荐
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950">
              顺着这些内容继续看
            </h2>
          </div>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}